import React, { useState, useEffect } from "react";
import $ from "jquery";
import "datatables.net-dt/js/dataTables.dataTables";
import "../../../../src/styles/userManagement.css";
import UpdateRisks from "./updateRisk"
import displayToastMessage from "../../Common/Alert/displayToastMessage";
import {Modal} from "@appkit4/react-components/modal"
import ModalFooter from "@appkit4/react-components/esm/modal/ModalFooter";
import PropTypes from 'prop-types';
export default function UpdateRiskTable(props) {
  let { SetTab } = props;
  const [messageScreen, setMessageScreen] = useState(false)
  const [modalVisible, setModalVisible] = useState(false);
  const [name, setName] = useState('')
  const [riskID, setRiskID] = useState('')
  const [service, setService] = useState('')
  const [owner, setOwner] = useState('')
  const [status, setStatus] = useState('')
  const [iC, setIC] = useState('')
  const data2 = [
    {
      "id": "1",
      "RiskID": "TP910",
      "Status": "Expired",
      "Name": "James",
      "ServiceName": "IT-Service",
      "BusinessOwner": "yash",
      "Date Issued": "11-Sep-2020",
      "InformationClassification": "NA"
    },

    {
      "id": "2",
      "RiskID": "TP789",
      "Status": "Open",
      "Name": "Rambabu",
      "ServiceName": "Business Service",
      "BusinessOwner": "Nidhi",
      "Date Issued": "15-Oct-2020",
      "InformationClassification": "NA"
    },
    {
      "id": "3",
      "RiskID": "TP112",
      "Status": "Close",
      "Name": "Ram",
      "ServiceName": "IT-Service",
      "BusinessOwner": "Ram",
      "Date Issued": "16-Nov-2020",
      "InformationClassification": "NA"
    },
    {
      "id": "4",
      "RiskID": "TP456",
      "Status": "Expired",
      "Name": "Nagaraj",
      "ServiceName": "NA",
      "BusinessOwner": "Drake",
      "Date Issued": "21-Oct-2020",
      "InformationClassification": "NA"
    },
    {
      "id": "5",
      "RiskID": "TP123",
      "Status": "Close",
      "Name": "James",
      "ServiceName": "Business Service",
      "BusinessOwner": "Post Malone",
      "Date Issued": "16-Feb-2020",
      "InformationClassification": "NA"
    },
  ]

  const riskTable = () => {
    // $(document).ready(function () {
    //   $('#risk').DataTable({
    //     "scrollX": true, "initComplete": function (settings, json) {
    //       $('.dataTables_scrollBody thead tr').css({ visibility: 'collapse' });
    //     }, data: data2,
    //     destroy: true,
    //     info: false,
    //     language: {
    //       paginate: {
    //         next: '&gt;', // or '→'
    //         previous: '&lt;' // or '←' 
    //       }
    //     },
    //     fields: [
    //       {
    //         label: "Risk ID",
    //         name: "Risk ID",
    //       },
    //       {
    //         label: "Status",
    //         name: "Status",
    //       },
    //       {
    //         label: "Third Party Name:",
    //         name: "Third Party Name",
    //       },
    //       {
    //         label: "Service Name:",
    //         name: "Service Name",
    //       },
    //       {
    //         label: "Business Owner:",
    //         name: "Business Owner",
    //       },
    //       {
    //         label: "Date Issued:",
    //         name: "Date Issued",
    //       },


    //     ],
    //     columns: [
    //       { data: "RiskID" },
    //       {
    //         render: function (data, type, row) {
    //           let stylesClass
    //           switch (row["Status"]) {
    //             case "Expired":
    //               stylesClass = "Expired-status";
    //               break;
    //             case "Open":
    //               stylesClass = "Open-status";
    //               break;
    //             case "Close":
    //               stylesClass = "Close-status";
    //               break;
    //             default:
    //               stylesClass = "";
    //           }
    //           return (
    //             `<div class="bia-status ${stylesClass}">${row["Status"]}</div>`
    //           )
    //         }
    //       },
    //       { data: "Name" },
    //       { data: "ServiceName" },
    //       { data: "BusinessOwner" },
    //       { data: "Date Issued" },
    //       { data: "InformationClassification" },

    //       {
    //         render: function (data, type, row) {
    //           return (
    //             '<span class=" appkiticon icon-edit-fill pointer" data-toggle="modal" data-target="#updateModal" id="edit_*_*' +
    //             row.id +
    //             "*_*" +
    //             row.Name +
    //             "*_*" +
    //             row.RiskID +
    //             "*_*" +
    //             row.ServiceName +
    //             "*_*" +
    //             row.BusinessOwner + "*_*" +
    //             row["Status"] +
    //             "*_*" +
    //             row.InformationClassification +
    //             '"> </span> &nbsp;<span class=" appkiticon icon-delete-fill pointer" data-toggle="modal" data-target="#deleteModal" id="ven_del' +
    //             row.org_id +
    //             '"> </span>'
    //           );
    //         },
    //       },
    //     ]
    //   });
    // });
  }
  useEffect(() => {
    riskTable()
  }, []);
  const handleCancel = () => {
    setModalVisible(false);
  };
  const handleConfirm = () => {
    setModalVisible(false);
    displayToastMessage("Record deleted successfully")

  };
  $(document).on("click", "[id*='ven_del']", function () {
    setModalVisible(true);
  });
  $(document).on("click", "[id*='edit_']", function () {
    let idData = this.id.split("*_*");
    setName(idData[2])
    setRiskID(idData[3])
    setService(idData[4])
    setOwner(idData[5])
    setStatus(idData[6])
    setIC(idData[7])
    setMessageScreen(true);
  });

  const sendBackHandler = () => {
    setMessageScreen(false)
    riskTable()
  }
  return (
    <div className="App">
      {messageScreen ?
        < UpdateRisks sendBack={sendBackHandler} status={status} Owner={owner} ID={riskID} SetTab={SetTab} info={iC} Service={service} Name={name} />

        :
        <div className="col-lg-12 mt-3 pl-1">
          <table id="risk" className="table menu-tableAlignment-width">
            <thead className="table-header-etp">
              <tr>
                <th>Risk ID</th>
                <th>Status</th>
                <th>Third Party Name</th>
                <th>Service Name</th>
                <th>Business Owner</th>
                <th>Date Issued</th>
                <th>Information Classification</th>
                <th data-orderable="false">Action</th>
              </tr>
            </thead>
          </table>
        </div>
      }
      <div>
        <Modal
          className="baseline-modal-showcase"
          visible={modalVisible}
          onCancel={handleCancel}
          bodyStyle={{ maxHeight: "280px" }}
          footerStyle={{ paddingTop: "8px", marginTop: "-8px"}}
          modalStyle={{ width: "49.75rem" ,maxHeight:"fit-content" }}
        >
          <div className="modal-title">Are you sure you want to delete the Request?</div>
          <ModalFooter>
            <div className="modal-footer">
              <button
                type="button"
                className="cancel-button"
                onClick={handleCancel}
              >
                No
           </button>

              <button
                type="submit"
                className="save-button m-l-2"
                onClick={() => handleConfirm()}
              >
                Yes
               </button>
            </div>
          </ModalFooter>
        </Modal>
      </div>
    </div>
  )
}

UpdateRiskTable.propTypes = {
  SetTab: PropTypes.any
}